import { useCallback, useContext } from 'react';
import { UploadButton } from 'src/components/Buttons';
import { useActivePosEntityContext } from 'src/contexts/ActivePosEntityContext';
import { Content } from 'src/contexts/ContentContext';
import { ModalContext } from 'src/contexts/ModalContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { ButtonProps } from 'src/core/ui';
import {
  UploadExternalIdProps,
  UploadExternalIds,
} from 'src/modals/UploadExternalIds';
import { ContentId } from 'src/utils/constants/contentId';
import { EntityWithRealTickets } from 'src/utils/ticketUtils';
import { ListingActionType, SaleActionType } from 'src/WebApiController';

import { ModalProps } from '../Modal';

export const LaunchUploadExternalIds = ({
  entityId,
  idOnMkp,
  variant,
  iconOnlyMode,
  dropdownItemMode,
  disabled,
  action,
  modalSize,
  ...modalProps
}: UploadExternalIdProps & {
  entityId: number;
  idOnMkp?: string | null;
  variant?: ButtonProps['variant'];
  iconOnlyMode?: boolean;
  dropdownItemMode?: boolean;
  disabled?: boolean;
  action:
    | ListingActionType.PredeliverExternalIds
    | ListingActionType.RedeliverExternalIds
    | SaleActionType.Fulfill
    | SaleActionType.Refulfill;
  modalSize?: ModalProps['size'];
}) => {
  const { setModal } = useContext(ModalContext);
  const { setActivePosEntity } =
    useActivePosEntityContext<EntityWithRealTickets>();

  const uploadExternalIds = useCallback(() => {
    setModal({
      children: <UploadExternalIds {...modalProps} />,
      clickOutsideToClose: true,
      size: modalSize ?? 'slide-in',
    });
  }, [setModal, modalProps, modalSize]);

  const onLaunchDialog = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      setActivePosEntity(entityId, idOnMkp);
      uploadExternalIds();
    },
    [setActivePosEntity, entityId, idOnMkp, uploadExternalIds]
  );

  if (dropdownItemMode) {
    return (
      <PosDropdownItem disabled={disabled} onClick={onLaunchDialog}>
        <Content
          id={
            action === ListingActionType.RedeliverExternalIds ||
            action === SaleActionType.Refulfill
              ? ContentId.ReuploadTicketIds
              : ContentId.UploadTicketIds
          }
        />
      </PosDropdownItem>
    );
  }

  return (
    <UploadButton
      disabled={disabled}
      variant={variant}
      iconOnlyMode={iconOnlyMode}
      onClick={onLaunchDialog}
      textContentId={
        action === ListingActionType.RedeliverExternalIds ||
        action === SaleActionType.Refulfill
          ? ContentId.ReuploadTicketIds
          : ContentId.UploadTicketIds
      }
    />
  );
};
